/**
 * Android-Zurück-Taste schließt zuerst das offene Overlay (Drawer, Coach-Sheet),
 * statt wegzunavigieren (Auftraggeber 12.06., Task F).
 *
 * Mechanik: Beim Öffnen wird ein History-Eintrag gepusht (gleiche URL). Drückt
 * der Nutzer Zurück, feuert popstate → wir schließen NUR das Overlay. Schließt
 * der Nutzer das Overlay manuell (✕/Backdrop/Auswahl), bleibt der gepushte
 * Eintrag stehen — der nächste Zurück-Druck verpufft dann einmal wirkungslos
 * (bewusster, einfacher Kompromiss statt fehleranfälligem history.back()-Jonglieren).
 *
 * Andere popstate-Logik (Kapitel-Navigation im Kurs-Screen) muss Overlay-Pops
 * ignorieren: dafür gibt es overlayIsOpen() — bei offenem Overlay übernimmt
 * ausschließlich dieser Hook den Zurück-Druck.
 */
import { useEffect, useRef } from "preact/hooks";

let openCount = 0;

/** Ist gerade irgendein Overlay (Drawer/Sheet) offen, das Zurück abfängt? */
export function overlayIsOpen(): boolean {
  return openCount > 0;
}

export function useBackClose(open: boolean, close: () => void): void {
  const closeRef = useRef(close);
  closeRef.current = close;

  useEffect(() => {
    if (!open) return;
    openCount++;
    try {
      // Stalen Overlay-Eintrag (von vorherigem manuellem Schließen) wiederverwenden,
      // statt zu stapeln — so kostet wiederholtes Öffnen/Schließen höchstens EINEN
      // wirkungslosen Zurück-Druck.
      const st = history.state as { overlay?: boolean } | null;
      if (!st?.overlay) history.pushState({ overlay: true }, "");
    } catch {
      /* ignore */
    }
    const onPop = () => {
      closeRef.current();
    };
    addEventListener("popstate", onPop);
    return () => {
      removeEventListener("popstate", onPop);
      openCount = Math.max(0, openCount - 1);
    };
  }, [open]);
}
